<template>
  <section id="foerdermittel">
    <v-container>

      <v-row justify="center">
        <h2 class="section-title">{{ lang.sanierung.caption }}</h2>
      </v-row>

      <v-row justify="center" align="center">
        <v-col cols="12" md="6" lg="6" xl="4" class="mt-4 mt-md-8 mt-lg-10">
          <p class="font-weight-medium mb-6 text-center text-md-start">{{ lang.sanierung.subtitle }}</p>
          <ul style="list-style: none; margin: 0 auto; max-width: 500px;" class="foerdermittel-liste">
            <li v-for="item in lang.sanierung.items" :key="item.caption" class="mt-2">
              <v-icon class="mr-2 primary-color" :icon="item.icon"></v-icon>
              {{ item.caption }}
            </li>
          </ul>

          <br>
          <div style="font-weight: bold;font-size: 18px" class="text-center text-md-start">
            {{ lang.sanierung.bottom_left_caption }}
          </div>
          <div style="margin-top: 10px" class="text-center text-md-start">
            {{ lang.sanierung.bottom_left_content }}
          </div>
        </v-col>

        <v-col cols="10" md="6" lg="6" xl="6"
               class="align-center d-flex justify-center mt-12">
          <!-- Kleines Bild, klickbar -->
          <v-img
              eager
              :src="sanierungImg"
              @error="sanierungImg = sanierungErrorImg"
              @click="dialog = true"
              class="cursor-pointer"
              max-width="100%"
          ></v-img>
        </v-col>
      </v-row>

      <v-row justify="center" class="mt-4">
        <v-col cols="12" md="8" class="text-center">
          <v-btn class="mt-6 text-white primary" size="large" href="#contact">{{ lang.sanierung.button_to_contact_link }}</v-btn>
        </v-col>
      </v-row>

      <v-dialog
          v-model="dialog"
          fullscreen
          transition="dialog-bottom-transition"
          persistent
          class="ma-6"
      >
        <v-card flat class="pa-0" style="height: 100vh; position: relative;">
          <!-- Close Icon oben rechts -->
          <v-btn
              icon
              color="white"
              @click="dialog = false"
              style="position: absolute; top: 10px; right: 10px; z-index: 10;"
              aria-label="Schließen"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>

          <v-img
              :src="sanierungImg"
              @error="sanierungImg = sanierungErrorImg"
              contain
              class="fill-height"
          ></v-img>
        </v-card>
      </v-dialog>

    </v-container>
  </section>
</template>

<style>
@media (min-width: 960px) {
  .foerdermittel-liste {
    max-width: unset !important;
  }
}
</style>

<script>
import lang from '@/lang/lang.js'

export default {
  data() {
    return {
      lang: lang,
      dialog: false,
      sanierungErrorImg: '/images/sanierung/sanierungsplan.jpg',
      sanierungImg: '/images/sanierung/sanierungsplan.webp',
    }
  }
}
</script>